import React, { createContext, ReactNode } from 'react';

interface CastAndCrewState {
  addCastModalOpen: boolean;
}

type CastAndCrewAction = { type: 'TOGGLE_ADD_CAST_AND_CREW_OPEN'; payload: boolean };

export const castAndCrewReducer = (state: CastAndCrewState, action: CastAndCrewAction): CastAndCrewState => {
  switch (action.type) {
    case 'TOGGLE_ADD_CAST_AND_CREW_OPEN':
      return { ...state, addCastModalOpen: action.payload };
    default:
      return state;
  }
};

export const initialCastAndCrewState: CastAndCrewState = {
  addCastModalOpen: false,
};

interface AddCastAndCrewContextType {
  state: CastAndCrewState;
  dispatch: React.Dispatch<CastAndCrewAction>;
}

export const AddCastAndCrewContext = createContext<AddCastAndCrewContextType | undefined>(undefined);

export interface AddCastAndCrewProviderProps {
  children: ReactNode;
}
